import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import axios from "./../../api/axios";
import "./styles/AdminDashboard.css";

const AdminDashboard = () => {
  const { auth, hasAccess } = useAuth();
  const [pageViews, setPageViews] = useState([]);

  const adminLinks = [
    { path: "/admin/users", label: "Manage Users" },
    { path: "/admin/messages", label: "View Messages" },
    { path: "/admin/orders", label: "View/Manage Orders" },
    { path: "/admin/products", label: "Manage Products" },
    { path: "/admin/tags-categories", label: "Manage Categories & Tags" },
    { path: "/admin/analytics", label: "Analytics and Page Views" },
    { path: "/admin/contacts", label: "Manage Contact Info" },
  ];

  const iconMap = {
    "/admin/users": ["fa-user-shield", "fa-solid fa-table-cells-row-lock"],
    "/admin/messages": ["fa-envelope-open-text", "fa-solid fa-envelope"],
    "/admin/orders": ["fa-receipt", "fa-solid fa-boxes-packing"],
    "/admin/products": ["fa-store", "fa-boxes-stacked"],
    "/admin/tags-categories": ["fa-tags", "fa-solid fa-list"],
    '/admin/analytics': ["fa-solid fa-magnifying-glass-chart", "fa-solid fa-chart-line"],
    '/admin/contacts': ["fa-solid fa-address-book", "fa-regular fa-id-badge"]
  };

  useEffect(() => {
    const fetchPageViews = async () => {
      try {
        const res = await axios.get("/api/admin/pageviews");
        setPageViews(res.data);
      } catch (error) {
        console.error("Error fetching page views:", error);
      }
    };

    fetchPageViews();
  }, []);

  const pathToPageName = {
    "/": "Home",
    "/about": "About",
    "/contact": "Contact",
    "/services": "Services",
    "/pricing": "Pricing",
    "/portfolio": "Portfolio",
    "/blog": "Blog",
    "/privacy-policy": "Privacy Policy",
    "/terms-of-service": "Terms of Service",
    "/shopping-cart": "Shopping Cart",
    "/our-process": "Our Process",
    "/shipping-returns": "Shipping & Returns",
    // fallback to dynamic for product pages or others
  };
  

  return (
    <div className="admin-dashboard">
      <h1 className="admin-heading">
        Welcome back, <span>{auth.user.name}</span>
      </h1>

      <div className="admin-cards-container">
        {adminLinks.map(({ path, label }) =>
          hasAccess(path) ? (
            <Link key={path} to={path} className="admin-card">
              {/* Left Icon */}
              {iconMap[path]?.[0] && (
                <div className="admin-card-icon icon-left">
                  <i className={`fa-solid ${iconMap[path][0]}`}></i>
                </div>
              )}

              {/* Right Icon */}
              {iconMap[path]?.[1] && (
                <div className="admin-card-icon icon-right">
                  <i className={`fa-solid ${iconMap[path][1]}`}></i>
                </div>
              )}

              {/* Main Content */}
              <div className="admin-card-body">
                <h2>{label}</h2>
              </div>
            </Link>
          ) : null
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
